import React from 'react';
import { Typography, TypographyProps } from '../Typography';
import { ClockOutlinedIcon, ClockOutlinedIconProps } from '../../icons/ClockOutlinedIcon';
import { Grid, GridProps } from '../../wag-react/core-components/grid';
export type ReadTimeProps = GridProps & {
  children: string;
  textProps?: Omit<TypographyProps, 'children'>;
  iconProps?: ClockOutlinedIconProps;
};
export const ReadTime = ({
  children,
  iconProps,
  textProps,
  ...rest
}: ReadTimeProps) => <Grid gridTemplateColumns="24px 1fr" alignItems="center" gridGap="8px" mb={['unset', null, '24px']} {...rest} data-sentry-element="Grid" data-sentry-component="ReadTime" data-sentry-source-file="index.tsx">
    <ClockOutlinedIcon fontSize="20px" {...iconProps} data-sentry-element="ClockOutlinedIcon" data-sentry-source-file="index.tsx" />
    <Typography m={0} fontSize={['14px', null, '16px']} {...textProps} style={{
    textTransform: 'uppercase',
    ...textProps?.style
  }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {children}
    </Typography>
  </Grid>;